export function contactForm() {
    return {
        sending: false,
        status: '', // 'success' | 'error'

        async submit() {
            this.status = ''
            this.sending = true

            const form = this.$el
            const data = {}
            for (const [key, value] of new FormData(form).entries()) {
                const k = key.replace(/\[\]$/, '')
                data[k] = data[k] ? data[k] + ', ' + value : value
            }

            try {
                const response = await fetch(form.action || window.location.href, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(data),
                })

                const result = await response.json()
                this.status = result.status === 'success' ? 'success' : 'error'

                if (this.status === 'success') {
                    form.reset()
                }
            } catch {
                this.status = 'error'
            } finally {
                this.sending = false
            }
        }
    }
}
